<template>
  <div v-if="feedbacks.data">
    <DashboardTitleSearch
      :property-name="property_name"
      :property-id="property_id"
      :category-id="cat_id"
    />
    <h2 v-if="stats.data">"{{ feedbacks.words }}" Phrase in {{ cat_name }}</h2>
    <span v-if="!feedbacks.data.length">No Feedback!</span>

    <div v-if="stats.data" class="full-box">
      <div class="dashboard-box-horizontal four-lines">
        <div class="box-number">#{{ stats.data.rank }}</div>
        <span class="box-header space-5"
          >{{ stats.data.category_name }} Impact Rank</span
        >
        <div class="box-number">{{ stats.data.satisfaction_impact }}%</div>
        <span class="box-header">Satisfaction Impact</span>
      </div>
      <div class="dashboard-box-horizontal">
        <div class="">
          <div
            v-if="stats.data.sentiment_score <= -11"
            class="sentiment-icons2 space-5"
          >
            <img src="../assets/mad.png" />
          </div>
          <div
            v-else-if="
              stats.data.sentiment_score > -11 &&
                stats.data.sentiment_score < 49
            "
            class="sentiment-icons2 space-5"
          >
            <img src="../assets/neutral.png" />
          </div>
          <div
            v-else-if="stats.data.sentiment_score > 49"
            class="sentiment-icons2 space-5"
          >
            <img src="../assets/happy.png" />
          </div>
        </div>
        <br />
        <span class="box-number space-5" style="align:left; color:green;"
          >{{
            (
              (stats.data.positive_sentiment_count / stats.data.total_count) *
              100
            ).toFixed(1)
          }}%</span
        >
        Positive Sentiment<br />
        <span class="box-number"
          >{{
            (
              (stats.data.negative_sentiment_count / stats.data.total_count) *
              100
            ).toFixed(1)
          }}%</span
        >
        Negative Sentiment
      </div>
      <div class="dashboard-box-horizontal">
        <span class="box-number">{{ stats.data.total_count }}</span>
        <span class="box-header">Frequency of Phrase</span>
        <span class="box-footer">past 6 weeks</span>
      </div>
    </div>

    <div class="full-box">
      <h2 class="bold">
        MOST COMMON "{{ feedbacks.words.toUpperCase() }}" CUSTOMER PHRASES
      </h2>
      <div class="word-cloud">
        <vue-word-cloud
          style="
            height: 340px;
            width: 100%;
          "
          :words="wordcloud.data"
          :color="
            ([, weight, sentiment]) =>
              sentiment > 49
                ? '#00a660'
                : sentiment > -11
                ? '#929292'
                : '#de4c40'
          "
          :spacing="0.8"
          :animation-duration="5"
          :animation-overlap="5"
          animation-easing="ease-in-out"
          font-family="Merienda"
        >
          <template v-slot="props">
            <div style="cursor: pointer;" @click="onWordClick(props.text)">
              {{ props.text }}
            </div>
          </template>
        </vue-word-cloud>
      </div>
    </div>
    <div class="feedback-list">
      <div
        v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
        class="pagination"
      >
        <button
          v-if="page > 1"
          class="button button-100 page-back"
          @click="pageBack"
        >
          Back
        </button>
        &nbsp;
        <div class="pagination-page">
          Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
        </div>
        <button
          v-if="page < Math.ceil(feedbacks.total_items / per_page)"
          class="button button-100 page-next"
          @click="pageNext"
        >
          Next
        </button>
      </div>
      <div class="clearfix" />
      <div
        v-for="feedback in feedbacks.data"
        :key="feedback.id"
        class="feedback-item"
      >
        <FeedbackItem :feedback="feedback" />
      </div>
      <div class="clearfix" />
      <div
        v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
        class="pagination"
      >
        <button
          v-if="page > 1"
          class="button button-100 page-back"
          @click="pageBack"
        >
          Back
        </button>
        &nbsp;
        <div class="pagination-page">
          Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
        </div>
        <button
          v-if="page < Math.ceil(feedbacks.total_items / per_page)"
          class="button button-100 page-next"
          @click="pageNext"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTitleSearch from "@/components/DashboardTitleSearch";
import FeedbackItem from "@/components/FeedbackItem";
import VueWordCloud from "vuewordcloud";
import api from "@/api/index";
const apiService = new api.APIServiceFeedbackDashboard();

export default {
  name: "DashboardFeedback",
  components: {
    DashboardTitleSearch,
    FeedbackItem,
    [VueWordCloud.name]: VueWordCloud
  },
  data() {
    return {
      feedbacks: [],
      wordcloud: [],
      stats: {},
      page: 1,
      per_page: 25,
      total_items: 0,
      total_pages: 0,
      property_id: this.$route.params.id,
      property_name: "",
      cat_id: parseInt(this.$route.params.cat_id),
      cat_name: ""
    };
  },
  created() {
    this.getPropertyFeedbackCategoryWordCloud();
    this.getPropertyWordCloudByCategoryByWordForWordCloudGraphic();
    this.getPropertyFeedbackCategoryNgramStats();
  },
  methods: {
    getPropertyFeedbackCategoryWordCloud: function() {
      apiService
        .getPropertyFeedbackCategoryWordCloud(
          this.$route.params.id,
          this.$route.params.cat_id,
          this.$route.params.word_id,
          this.page
        )
        .then(data => {
          this.boldString(data);
          this.feedbacks = data;
        });
    },
    getPropertyWordCloudByCategoryByWordForWordCloudGraphic: function() {
      apiService
        .getPropertyWordCloudByCategoryByWordForWordCloudGraphic(
          this.$route.params.id,
          this.$route.params.cat_id,
          this.$route.params.word_id,
          this.page
        )
        .then(data => {
          console.log(data);
          this.wordcloud = data;
        });
    },
    getPropertyFeedbackCategoryNgramStats: function() {
      apiService
        .getPropertyFeedbackCategoryNgramStats(
          this.$route.params.id,
          this.$route.params.cat_id,
          this.$route.params.word_id
        )
        .then(data => {
          this.stats = data;
          this.cat_name = data.data.category_name;
          this.$store.commit("setProperty", {
            id: this.$route.params.id,
            name: data.data.property_name
          });
        });
    },
    onWordClick: function(theword) {
      console.log("clicked");
    },
    boldString: function(data) {
      var strRegExp = new RegExp(data.words, "ig");
      for (var i = 0; i < data.data.length; i++) {
        data.data[i].feedback = data.data[i].feedback.replace(
          strRegExp,
          "<b>" + data.words + "</b>"
        );
      }
    },
    pageBack: function() {
      this.page = this.page - 1;
      this.getPropertyFeedbackCategoryWordCloud();
      window.scrollTo(0, 0);
    },
    pageNext: function() {
      this.page = this.page + 1;
      this.getPropertyFeedbackCategoryWordCloud();
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style>
#feedback {
  margin: 0 0;
}
.feedback-item {
  lost-column: 1/2;
}
.dashboard {
  lost-utility: clearfix;
}
.dashboard-box-horizontal {
  lost-column: 1/3;
  height: 160px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding: 28px 0;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #cfd1d3;
}
.dashboard-box-horizontal .box-header {
  font-size: 21px;
  display: block;
}
.dashboard-box-horizontal .box-number {
  font-size: 30px;
  font-weight: bold;
  color: #c03131;
}
.dashboard-box-horizontal .box-footer {
  font-size: 14px;
  display: block;
}
.space-5 {
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.sentiment-icons2 img {
  width: 30px;
  position: absolute;
  float: right;
}
.box-number-small {
  font-size: 19px;
}
.four-lines {
  padding: 16px;
}
.word-cloud {
  padding: 0 20px;
}
.feedback-list {
  lost-utility: clearfix;
}
.pagination {
  float: right;
  margin-bottom: 10px;
}
b {
  font-weight: bold;
}
.pagination-page {
  padding-top: 12px;
  padding-right: 5px;
  float: left;
}
.ngrams {
  padding: 0 3px 10px 10px;
  margin-bottom: 20px;
}
.ngrams-box {
  lost-column: 1/2;
}
.ngram span {
  font-size: 20px;
}
@media (max-width: 480px) {
  .full-box {
    lost-utility: clearfix;
  }
  h1 {
    font-size: 20px;
  }
}
</style>
